"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metadataKey = Symbol('rest:design:type');